import type { UserRoles } from '@bb/users';

export interface GroupMember {
  id: string;
  firstName: string;
  lastName: string;
  location: string;
  address: string;
  email: string;
  role: UserRoles;
  avatarFilestackId?: string;
  disabled?: boolean;
  isUnverified?: boolean;
  isDeleted?: boolean;
}

export interface TeamMember {
  id: string;
  firstName: string;
  lastName: string;
  location: string;
  address: string;
  email: string;
  role: UserRoles;
  avatarFilestackId?: string;
  disabled?: boolean;
  isUnverified?: boolean;
}

export type GroupOrTeamMember = GroupMember | TeamMember;

export const compareFirstAndLastName = (
  member1: GroupOrTeamMember,
  member2: GroupOrTeamMember,
) => {
  const result = member1.firstName.localeCompare(member2.firstName);
  return result !== 0
    ? result
    : member1.lastName.localeCompare(member2.lastName);
};

export const addDatacy =
  (key: string) =>
  ({ id }: { id: string }) =>
    ({ 'data-cy': `${key}-${id}` }) as React.HTMLAttributes<HTMLElement>;

export const addDatacyToHeader = (key: string) => () =>
  ({ 'data-cy': `${key}-header` }) as React.HTMLAttributes<HTMLElement>;
